var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGuide = function SvgGuide(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 19V5q0-.824.587-1.412A1.93 1.93 0 0 1 5 3h14q.824 0 1.413.587Q21 4.176 21 5v14q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21zM5 5v14h14V5h-2v6.125q0 .3-.25.438a.47.47 0 0 1-.5-.013l-1.225-.75q-.25-.15-.525-.15-.274 0-.525.15l-1.225.75a.47.47 0 0 1-.5.012.46.46 0 0 1-.25-.437V5z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGuide);
export { ForwardRef as ReactComponent };